const tr = {
  appointmentCategories:{
    attributes:{
      id:                   'Id',
      name:                 'Nome',
      created_at:           'Criado em',
      updated_at:           'Atualizado em',
      tags:                 'Tags',
    },
    extras:{
      create_appointment_category: 'Novo Categoria de Consulta',
      edit_appointment_category: 'Editando Categoria de Consulta',
      show_appointment_category: 'Visualizando Categoria de Consulta',
    },
    defSingular: 'Categoria de Consulta',
    defPlural: 'Categorias de Consulta',
  }
};

export default tr;
